import React, { Component } from 'react'
import { Input, Checkbox, Icon } from 'loyal-react'
import PropTypes from 'prop-types'
import Delay from '../../Interval/Delay'

export default class Body extends Component {
  constructor (props) {
    super(props)
    this.state = {
      credit: 0,
      // TODO: trazer total de pontos do participante
      points: this.props.balance.pointsValue,
      checked: false
    }
    this.props.handleRechargeCredits(0)
    this.props.handleRechargePoints(0)
  }

  async handleCredit (el) {
    let val = el.target.value
    if (val) {
      let interval = this.props.intervalObservable
      let timeoutValue = 1500
      let delayedCallBack = await Delay(interval, timeoutValue, val, async (val) => {
        this.props.handleRechargePoints(val)
        let miles = await this.convertPoints(val)
        this.setState({ credit: miles })
        this.props.handleRechargeCredits(miles)
        if (this.state.checked) {
          this.setState({ checked: false })
        }
      })
      this.props.handleIntervalObservable(delayedCallBack)
    }
  }

  async callHandleCredits (el) {
    this.props.handleRechargePoints(el.target.value)
    let miles = await this.convertPoints(el.target.value)
    this.setState({ credit: miles })
    this.props.handleRechargeCredits(miles)
    if (this.state.checked) {
      this.setState({ checked: false })
    }
  }

  async handlePoint (el) {
    if (el.target.checked) {
      this.props.handleRechargePoints(this.state.points)
      let miles = await this.convertPoints(this.state.points)
      this.setState({ credit: miles })
      this.props.handleRechargeCredits(miles)
    } else {
      this.setState({ credit: 0 })
      this.props.handleRechargeCredits(0)
    }
    this.setState({ checked: !this.state.checked })
  }

  async convertPoints (points) {
    let res = await this.props.handlePointsConversion(
      points,
      this.props.accessToken
    )
    return res !== undefined && res.money >= 0 ? res.money : 0
  }

  render () {
    return (
      <div className='d-flex justify-content-between align-items-md-start align-items-center flex-column flex-md-row'>
        <div className='col-md-6 col-12 p-md-0'>
          <Input
            id='credit'
            label='Quantos pontos deseja creditar'
            type='number'
            onChange={e => this.handleCredit(e)} />
          <Checkbox
            id='points'
            label={`Creditar todos os meus ${this.state.points} pontos`}
            checked={this.state.checked}
            onChange={e => this.handlePoint(e)} />
        </div>
        <div className='my-2 my-md-0 mt-md-1'>
          <Icon iconName='icon_equal' className='color-brand-2-like' />
        </div>
        <div className='col-md-5 col-12 p-md-0'>
          <p className='mb-1 mb-md-2'><strong>Valor a ser creditado no Cartão Like Mais</strong></p>
          <h3 className='color-brand-2-like'>{`R$ ${this.state.credit}`}</h3>
        </div>
      </div>
    )
  }
}

Body.propTypes = {
  handleRechargePoints: PropTypes.func,
  handleRechargeCredits: PropTypes.func,
  handlePointsConversion: PropTypes.func,
  accessToken: PropTypes.string,
  balance: PropTypes.object,
  intervalObservable: PropTypes.any,
  handleIntervalObservable: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/features/LikePlus/Tabs/Recharge/Body.js